<template>
  <div class="container-fluid full-width-page-wrapper">
    <h3 class="font-weight-bold page-title mb-4">All Conferences</h3>
    <ifac-conference-public-list
      :fetch-conferences="fetchConferences"
      :is-authenticated="isAuthenticated"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { IfacConferencePublicList } from '@ifac/ui';
import ConferencesPublic from '@/services/Api/Public/Conferences';

export default {
  name: 'ConferencesAll',
  components: {
    IfacConferencePublicList,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
  },
  methods: {
    fetchConferences(params) {
      return ConferencesPublic.all(params);
    },
  },
};
</script>
